import { IconButton, css, CircularProgress } from '@mui/material';
import React from 'react';
import { useCallback, useEffect, useRef, useState } from 'react';
import ExposureIcon from '@mui/icons-material/Exposure';

import { IAbsoluteGain, useSeismicStore } from '../stores/useSeismicStore';
import { AbsoluteGainMenu } from './AbsoluteGainMenu';
import { GeopostPopover } from 'components/GeopostPopover';

export const GainMenu2D = () => {
    const { absoluteGain, setAbsoluteGain } = useSeismicStore(state => ({
        absoluteGain: state.absoluteGain,
        setAbsoluteGain: state.setAbsoluteGain
    }));

    const [ gainFactor, setGainFactor ] = useState(0);
    const lastGainFactorRef = useRef(gainFactor);

    const [gainMenuAnchor, setGainMenuAnchor] = useState<HTMLElement | null>(null);

    const [ defaultAbsoluteGain, setDefaultAbsoluteGain ] = useState<IAbsoluteGain | null>(null);

    const handleAbsoluteGainChange = useCallback((value: IAbsoluteGain) => {
        console.log(value.min, value.max);
        setAbsoluteGain({
            ...absoluteGain,
            min: value.min,
            max: value.max
        });
    }, [absoluteGain]);

    useEffect(() => {
        if (!defaultAbsoluteGain && !(absoluteGain.max === 0 && absoluteGain.min === 0)) {
            setDefaultAbsoluteGain(absoluteGain);
        }
    }, [absoluteGain]);

    return (
        <React.Fragment>
            {
                !defaultAbsoluteGain ?
                    <CircularProgress sx={{color: 'white'}}/>
                    :
                    <React.Fragment>
                        <IconButton id='gains' color='inherit' onClick={(event) => setGainMenuAnchor(current => !current? event.currentTarget : null)}>
                            <ExposureIcon color='inherit' titleAccess='Display gain options' style={{ cursor: 'pointer', fontSize: 26 }}></ExposureIcon>
                        </IconButton>
                        <GeopostPopover anchorEl={gainMenuAnchor} onClose={() => setGainMenuAnchor(null)}>
                            <AbsoluteGainMenu absoluteGain={absoluteGain} onChange={handleAbsoluteGainChange} defaultAbsoluteGain={defaultAbsoluteGain}/>
                        </GeopostPopover>

                    </React.Fragment>
            }
        </React.Fragment>

    );
};